"use client";
import JobTypeFilter from "./JobTypeFilter";
import DatesFilter from "./DatesFilter";
import SalaryFilter from "./SalaryFilter";
import CountryFilter from "./CountryFilter";
import CountriesStatesFilter from "./CountriesStatesFilter";
import ExperienceLevelFilter from "./ExperienceLevelFilter";
import useBrowseJobsFiltersStore from "@store/browseJobsFiltersStore"; // Adjust path as needed
import { useIntl } from "react-intl";
import { FunnelIcon } from "@heroicons/react/24/outline";
import JobCategoryFilter from "./JobCategoryFilter";

type Props = {
  jobTypes: any;
  jobCategories: any;
  countries: any;
  countriesStates: any;
  careerLevels: any;
};

const Filters = ({
  jobTypes,
  jobCategories,
  countries,
  countriesStates,
  careerLevels,
}: Props) => {
  const intl = useIntl();
  const translation = intl.messages;
  const jobsTranslation: any = translation["jobs"];
  const FiltersTranslation: any = jobsTranslation["filters"];

  const {
    clearJobTypes,
    clearJobCategories,
    clearDateFilters,
    resetRange,
    clearCountries,
    clearCountriesStates,
    clearExperience,
  } = useBrowseJobsFiltersStore();

  const handleClearAll = () => {
    clearJobTypes();
    clearJobCategories();
    clearDateFilters();
    resetRange();
    clearCountries();
    clearCountriesStates();
    clearExperience();
  };

  return (
    <div className="w-full">
      <header className="h-[72px] lg:h-[60px] rounded-t-[12px] border-[#E7E7E7] px-5 border-b-4 lg:border-b border-0 lg:border lg:mb-5 flex items-center justify-between pr-16 lg:pr-5">
        <h3 className="font-semibold text-[#1F2223] text-base">All Filters</h3>

        <button
          onClick={handleClearAll}
          className="flex flex-row items-center gap-1.5 px-3 py-2 rounded-lg bg-[#F7F7F7] text-sm font-normal"
        >
          <FunnelIcon className="w-4 h-4" /> {FiltersTranslation["clear"]}
        </button>
      </header>
      <div className="py-5 px-5 border-0 lg:border border-[#E7E7E7] divide-y divide-[#E7E7E7]">
        <JobCategoryFilter jobCategories={jobCategories} />
        <JobTypeFilter jobTypes={jobTypes} />
        <DatesFilter />
        <SalaryFilter />
        <CountryFilter countries={countries} />
        <CountriesStatesFilter countriesStates={countriesStates} />
        <ExperienceLevelFilter Experiences={careerLevels} />
      </div>
    </div>
  );
};

export default Filters;
